import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'

function PlayerStats({playerId}) {

    const [stats, setStats] = useState([])
    const [statsSorted, setStatsSorted] = useState([])

    const [totalFixtures, setTotalFixtures] = useState(0)
    const [totalGoals, setTotalGoals] = useState(0)
    const [totalAssists, setTotalAssist] = useState(0)

    useEffect(() => {

        try {
            const playerStatsRef = firestore.collection("players-fb").doc(playerId).collection("player-stats");
            playerStatsRef.orderBy("season").onSnapshot(({docs}) => {
                const playerStats = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setStats(playerStats);
            })
        } catch (error) {
            
        }

    }, [playerId])

    useEffect(() => {

        if (stats) {
            const sortedStats = stats.sort((a, b) => {
                return b.season - a.season
            })
            setStatsSorted(sortedStats)
        }

    }, [stats])

    useEffect(() => {
        if (stats.length) {
            const goals = stats.map(item => {
                return +item.goals
            })

            const matches = stats.map(item => +item.fixtures)
            const assists = stats.map(item => +item.assists)
            
            const totalMatches = sum(matches)
            const totalGoals = sum(goals) 
            const totalAssists = sum(assists)

            setTotalFixtures(totalMatches)
            setTotalGoals(totalGoals)
            setTotalAssist(totalAssists)
        }
    }, [stats])

    function sum(nums) {
        if (nums) {
            return nums.reduce((a, b) => a + b)
        } else {
            return 0
        }
        
    }

    return (
        <table className="table table-bordered table-hover table-striped">
            <thead>
                <tr>
                    <th>S</th>
                    <th>K</th>
                    <th>M</th>
                    <th>A</th>
                </tr>
            </thead>
            <tbody>
                {statsSorted?.map((stat, index) => {
                    return (
                        <tr key={index}>
                            <td>{stat.season}</td>
                            <td>{stat.fixtures}</td>
                            <td>{stat.goals}</td>
                            <td>{stat.assists}</td>
                        </tr>
                    )
                })}
                <tr>
                    <td>Totalt</td>
                    <td>{totalFixtures}</td>
                    <td>{totalGoals}</td>
                    <td>{totalAssists}</td>
                </tr>
            </tbody>
        </table>
    )
}
export default PlayerStats